import React, { useContext, useMemo, useRef, useState } from "react";

import './GrillasStyles.css';
import authContext from "../../context/authentication/authContex";
import activoContext from "../../context/activoContex/activoContex";
import informesContext from "../../context/informesContext/informesContext";
import usuariosContext from "../../context/usuarios/usuariosContext";
import normalizeText from "../../utils/normalizeText";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";

import SearchInput from "../searchInput/SearchInput";
import SelectColumns from "./SelectColumns";
import Table from "./Table";

const GrillaConsumoHorasMensual = ({setGridToShow}) => {

    const aContext = useContext(authContext);
    const { usuario } = aContext;

    const acContext = useContext(activoContext);
    const { getConsumoHorasMensualReporte } = acContext;

    const uContext = useContext(usuariosContext);
    const { saveColumnsPreferences } = uContext;

    const iContext = useContext(informesContext);
    const { generarInformeExcel } = iContext;

    let columnsPreferences = useMemo(()=> usuario?.columnsPreferences?.columnasConsumoHorasMensual ?? [], [usuario]);

    const dataOriginal = useRef(undefined);
    const [data, setData] = useState(undefined);
    const [filter, setFilter] = useState('');
    const [showSelectColumns, setShowSelectColumns] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dateFrom, setDateFrom] = useState(''); // YYYY-MM-DD
    const [dateTo, setDateTo] = useState('');     // YYYY-MM-DD

     const [columns, setColumns] = useState([
        { width: 200, property: 'codActivo', title: 'Codigo', visible: true },
        { width: 400, property: 'name', title: 'Nombre', visible: true },
        { width: 180, property: 'hsInicial', title: 'Horometro Inicial', visible: true },
        { width: 180, property: 'hsFinal', title: 'Horometro Final', visible: true },
        { width: 150, property: 'horas', title: 'Horas', visible: true },
        { width: 180, property: 'kmInicial', title: 'KM Inicial', visible: true },
        { width: 180, property: 'kmFinal', title: 'KM Final', visible: true },
        { width: 150, property: 'kilometros', title: 'Kilometros', visible: true }
    ]);

    // Rango valido: ambas fechas presentes y 'desde' no posterior a 'hasta'
    const rangoValido = !!dateFrom && !!dateTo && dateFrom <= dateTo;

    const handleBuscar = async () => {
        if(!rangoValido) return;
        setLoading(true);
        setFilter('');

        const res = await getConsumoHorasMensualReporte(dateFrom, dateTo);

        if(res?.data){
            dataOriginal.current = res.data;
            setData(res.data);
        }else{
            dataOriginal.current = [];
            setData([]);
        }
        setLoading(false);
    }

    const handleChangeColumnsVisible = (e, c, i) => {
        setColumns(prev => prev.map((col, idx) => idx == i ? {...col, visible: e.target.checked} : col));
    }

    const handleGenerarInforme = async() => {
        let dataToExcel = [];
        let columnsTitle = columns.filter(c => c.visible).map(c => c.title);
        dataToExcel.push(columnsTitle);

        for(const row of data){
            let rowModelado = [];
            for(const col of columns){
                if(!col.visible) continue;
                rowModelado.push(
                    col.childProperty
                    ?
                    row[col.property]?.[col.childProperty] : row[col.property]
                );
            }

            if(rowModelado.length > 0) dataToExcel.push(rowModelado);
        }
        await generarInformeExcel(dataToExcel, `ConsumoHoras_${dateFrom}_${dateTo}`);
    }

    // Filtro por texto sobre data original
    React.useEffect(()=>{
        if(dataOriginal.current == undefined) return;
        if(filter != ''){
            const nFilter = normalizeText(filter);
            setData(dataOriginal.current.filter(r => normalizeText(r.codActivo ?? '').includes(nFilter) || normalizeText(r.name ?? '').includes(nFilter)));
        }else{
            setData(dataOriginal.current);
        }
    },[filter]);

    React.useEffect(()=>{
        if(columnsPreferences && columnsPreferences.length > 0){
            setColumns(prev => prev.map(c => ({...c, visible: columnsPreferences.includes(c.property)})));
        }
    },[columnsPreferences]);

    return <div className="grillaInformeDiv">
        <div className="utilitiesDiv consumoHorasMensual">
            <button onClick={()=>setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
            <div className="periodoFilterDiv">
                <input
                    type="date"
                    title="Desde"
                    value={dateFrom}
                    max={dateTo || undefined}
                    onChange={(e)=>setDateFrom(e.target.value)}
                />
                <input
                    type="date"
                    title="Hasta"
                    value={dateTo}
                    min={dateFrom || undefined}
                    onChange={(e)=>setDateTo(e.target.value)}
                />
                <button id="searchByPeriod" className={!rangoValido || loading ? 'disabled' : ''} disabled={!rangoValido || loading} onClick={()=>handleBuscar()}>Buscar</button>
            </div>
            <SearchInput filter={filter} buscar={setFilter}/>
            <button className="selectColumnsBtn" onClick={()=>setShowSelectColumns(true)}><FontAwesomeIcon className="iconArrowBack" icon={faTableCells}/></button>
            <button disabled={loading || data == undefined || data.length == 0} className="downloadBtn" onClick={handleGenerarInforme}>Descargar .xlsx <FontAwesomeIcon className="iconArrowBack" icon={faDownload}/></button>
        </div>
        {
            loading ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3>
            : data == undefined ? <h3 className="warningStatusMsg">Seleccione un rango de fechas (desde / hasta) y presione Buscar</h3>
            : data.length == 0 ? <h3 className="warningStatusMsg">No hay datos para el rango seleccionado</h3>
            : <Table array={data} columns={columns} setColumns={setColumns}/>
        }
        {
            showSelectColumns && <SelectColumns setShowSelectColumns={setShowSelectColumns} handleChangeColumnsVisible={handleChangeColumnsVisible} columns={columns} saveColumnsPreferences={saveColumnsPreferences} usuario={usuario} columnsName={"ConsumoHorasMensual"}/>
        }
    </div>
}

export default GrillaConsumoHorasMensual;
